import React from "react";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Collection from "../Pages/Collection/Collection";
import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Collectiontheme() {
  return (
    <>
      <Header />
      <Collection />
      <Latestupdate />
      <Footer />
    </>
  );
}
